import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UaService } from '@ecm/consumer';
import { EcmRouterModule, LinkService, RouterService, TrackingData } from '@ecm/router';

import { UniverseEnum } from '../../../../business/api/dashboard/universeEnum';
import { ProtectedHouseContractViewModel } from '../../../../business/model/crossroads/contracts-options/protectedHouse-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { AbstractComponent } from '../../../shared/abstract.component';

@Component({
    selector: 'protected-house-contract',
    templateUrl: 'protected-house-contract.html',
    styleUrls: ['protected-house-contract.css'],
    standalone: true,
    imports: [AsyncPipe, EcmRouterModule],
})
export class ProtectedHouseContractComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: ContractsViewModel;

    @Input()
    public borderBottom = true;

    @Input()
    public universe: UniverseEnum;

    public mixedSoshPicto = 'assets/dashboard/images/mini-logo-sosh.png';
    public mixedOrangePicto = 'assets/dashboard/images/mini-logo-orange.png';

    public protectedHouseContractViewModel: ProtectedHouseContractViewModel;

    private readonly trackingArea: string = 'care_selecteurcontrat_offre';

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        private readonly translate: TranslateService,
        private readonly linkService: LinkService,
    ) {
        super(uaService, routerService);
        translate.use('fr');
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (this.viewModel.contract) {
            this.protectedHouseContractViewModel = this.viewModel.contract as ProtectedHouseContractViewModel;
        }
    }

    /**
     * get Sosh or Orange icon
     * @return {string}
     */
    public getIcon(): string {
        let icon: string = null;
        if (this.universe === UniverseEnum.MIXED && this.protectedHouseContractViewModel.picto) {
            if (
                this.viewModel.brand.toUpperCase() === UniverseEnum.SOSH &&
                this.protectedHouseContractViewModel.picto.toUpperCase() === UniverseEnum.ORANGE
            ) {
                icon = this.mixedSoshPicto;
            } else if (
                this.viewModel.brand.toUpperCase() === UniverseEnum.ORANGE &&
                this.protectedHouseContractViewModel.picto.toUpperCase() === UniverseEnum.ORANGE
            ) {
                icon = this.mixedOrangePicto;
            }
        }
        return icon;
    }

    /**
     * Open button link for multi contract
     */
    public openProtectedHouseContract(): void {
        this.translate.get('dashboard.contractsAndOptions.multiContract').subscribe((multiContract: any) => {
            this.linkService.openLink(
                this.protectedHouseContractViewModel?.linkInternet,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.contractsAndOptions,
                        trackingArea: this.trackingArea,
                        trackingName: multiContract['button'],
                    },
                }),
                null,
                null,
                false,
            );
        });
    }
}
